import _ from 'lodash';

export default function configureChannels( app ) {

  app.on( 'login', ( authResult, params ) => {
    const provider = params.provider;

    if ( provider === 'rest' ) {
      // Params for rest contains req/res
      const { req, res } = params;
      // The rest of this doesn't apply for REST connections
      return;
    }

    const { socket, connection } = params;
  } );

}
